import React from 'react';
import PropTypes from 'prop-types';
import { Footer } from '../Footer';
import { Mothership } from '../MothershipSection';
import { Header } from '../Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/style/font.css';
import '../../assets/style/style.css';
import '../../../node_modules/swiper/dist/css/swiper.css';
const Layout = ({ children, mode, showMothership, updateSelectOption }) => (
  <>
    <Header mode={mode} />
    <div className='mainContainerMargin'>{children}</div>
    {showMothership && <Mothership />}
    <Footer updateSelectOption={updateSelectOption} />
  </>
);

Layout.propTypes = {
  showMothership: PropTypes.bool
};

Layout.defaultProps = {
  showMothership: true
};

export { Layout };
